import { CellSelection, TableContentData } from '../../../../../common/table/TableTypes';
import { getColumnCount, getRowCount } from '../../../../../common/table/utils/tableCellDataPropertyUtils';
import { getEndCol, getEndRow, getStartCol, getStartRow } from './tableSelectionAccessors';
import { isSelectingRefColHeader, isSelectingRefRowHeader } from './tableSelectionPredicateUtils';

/**
 * Returns the inclusive number of rows covered by a selection.
 */
export const getNRowsInSelection = (cellSelection: CellSelection): number =>
    Math.abs(getEndRow(cellSelection) - getStartRow(cellSelection)) + 1;

/**
 * Returns the inclusive number of columns covered by a selection.
 */
export const getNColsInSelection = (cellSelection: CellSelection): number =>
    Math.abs(getEndCol(cellSelection) - getStartCol(cellSelection)) + 1;

/**
 * Returns how many columns are not covered by the selection.
 **/
export const unselectedColCount = (data: TableContentData, selection: CellSelection): number => {
    if (isSelectingRefRowHeader(selection)) return 0;

    return getColumnCount(data) - getNColsInSelection(selection);
};

/**
 * Returns how many rows are not covered by the selection.
 */
export const unselectedRowCount = (data: TableContentData, selection: CellSelection): number => {
    if (isSelectingRefColHeader(selection)) return 0;

    return getRowCount(data) - getNRowsInSelection(selection);
};
